import type { FallbackKey } from '@common/config/config.type'
import { getNavigationUrls } from '@common/config/navigation'
import { AppEnvironment } from '@common/enums/appEnvironment.enum'

const ENV_VAR_BY_APP: Record<FallbackKey, string | undefined> = {
  portal: process.env.NEXT_PUBLIC_WEB_PORTAL_URL,
  vision: process.env.NEXT_PUBLIC_WEB_VISION_URL,
  modules: process.env.NEXT_PUBLIC_WEB_MODULES_URL,
  gateway: process.env.NEXT_PUBLIC_WEB_GATEWAYS_URL,
  insights: process.env.NEXT_PUBLIC_WEB_INSIGHTS_URL,
  academy: process.env.NEXT_PUBLIC_WEB_ACADEMY_URL,
  docs: process.env.NEXT_PUBLIC_WEB_DOCS_URL,
  conference: process.env.NEXT_PUBLIC_WEB_CONFERENCE_URL,
}

type ResolveAppUrlOptions = {
  localOverride?: string
}

export function resolveAppUrl(appKey: FallbackKey, options?: ResolveAppUrlOptions): string {
  const envUrl = ENV_VAR_BY_APP[appKey]?.trim()

  if (envUrl && !envUrl.startsWith('BAKED_')) {
    return envUrl
  }

  if (options?.localOverride && process.env.NEXT_PUBLIC_APP_ENV === AppEnvironment.LOCALHOST) {
    return options.localOverride
  }

  return getNavigationUrls()[appKey]
}
